// extracted by mini-css-extract-plugin
module.exports = {"footerNavigation":"default_footerNavigation__PPOYS","footerContainer":"default_footerContainer__uYYzR","listHeading":"default_listHeading__YdlgV","link":"default_link__NWCaT"};